import { Component, Input } from '@angular/core';
import { Channel } from 'ops/common/models/channel';
import { GaugeGraph } from 'ops/common/models/graphs';

@Component({
    selector: 'app-analog-graph',
    templateUrl: './analog-graph.component.html',
    styleUrls: ['./analog-graph.component.css'],
    standalone: false
})
export class AnalogGraphComponent {
    @Input() graph: GaugeGraph;
    @Input() channels: { [key: string | number]: Channel };
}
